import request from './interceptor'

// 获取订单列表
export function getOrders(params) {
  return request({
    url: '/v1/door-recycling/orders',
    method: 'get',
    params
  })
}

// 获取统计数据
export function getStats(params) {
  return request({
    url: '/v1/door-recycling/stats',
    method: 'get',
    params
  })
}

// 订单详情
export function getOrderDetail(id) {
  return request({
    url: `/v1/door-recycling/orders/${id}`,
    method: 'get'
  })
}

// 转交订单
export function transferOrder(id, data) {
  return request({
    url: `/v1/door-recycling/orders/${id}/transfer`,
    method: 'post',
    data
  })
}

// 取消订单
export function cancelOrder(id, data) {
  return request({
    url: `/v1/door-recycling/orders/${id}/cancel`,
    method: 'post',
    data
  })
}
